<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="con"></a>contents</h1>
<p class="toc"><a href="#/08_afirstthing#first">A First Thing to Remember</a></p>
<p class="toc"><a href="#/09_apreview#pre">A Preview of Your Sacred Walk</a></p>
<p class="toc"><a href="#/10_sacredspiral#walk">Walking the Sacred Spiral</a></p>
<p class="toc1"><a href="#/11_loopone#c1">Loop One</a></p>
<p class="toc2"><a href="#/11_loopone#c1">Feel the Spark of Longing and Open the Sacred Spiral</a></p>
<p class="toc1"><span href="#/12_looptwo#c2" title="Link target outside of Sample">Loop Two</span></p>
<p class="toc2"><span href="#/12_looptwo#c2" title="Link target outside of Sample">Listen to Your Soul's Stories</span></p>
<p class="toc1"><span href="#/13_loopthree#c3" title="Link target outside of Sample">Loop Three</span></p>
<p class="toc2"><span href="#/13_loopthree#c3" title="Link target outside of Sample">Honor your Soul's Birth Choices</span></p>
<p class="toc1"><span href="#/14_loopfour#c4" title="Link target outside of Sample">Loop Four</span></p>
<p class="toc2"><span href="#/14_loopfour#c4" title="Link target outside of Sample">Remember Your Soul's Divine Purpose</span></p>
<p class="toc1"><span href="#/15_loopfive#c5" title="Link target outside of Sample">Loop Five</span></p>
<p class="toc2"><span href="#/15_loopfive#c5" title="Link target outside of Sample">Re-visit, Re-see, and Re-member Your Past</span></p>
<p class="toc1"><span href="#/16_loopsix#c6" title="Link target outside of Sample">Loop Six</span></p>
<p class="toc2"><span href="#/16_loopsix#c6" title="Link target outside of Sample">Serve Your Soul's Divine Purpose</span></p>
<p class="toc1"><span href="#/17_loopseven#c7" title="Link target outside of Sample">Loop Seven</span></p>
<p class="toc2"><span href="#/17_loopseven#c7" title="Link target outside of Sample">Live a Life You Love and Close the Sacred Spiral</span></p>
<p class="toc"><span href="#/18_alastthing#last" title="Link target outside of Sample">A Last Thing to Remember</span></p>
<p class="toc"><span href="#/19_acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/20_bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/21_resources#res" title="Link target outside of Sample">Resources</span></p>
<p class="toc"><span href="#/22_credits#cre" title="Link target outside of Sample">Credits</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_contents.vue?2fdab4fc